import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ r, size = 50 }) => {
  const half = size / 2;
  const viewBox = `${half} ${half} ${size} ${size}`;
  return (
    <svg className="circular" viewBox={viewBox}>
      <circle className="path"
              cx={size} cy={size} r={r} fill="none" strokeWidth="2"
              strokeMiterlimit="10"/>
    </svg>
  );
};

Spinner.defaultProps = {
  r: 15
};

Spinner.propTypes = {
  r: PropTypes.number
};

export default Spinner;
